import { useEffect, useState } from 'react';

import PostHog from '../lib/utils/posthog';

/**
 * Returns whether a PostHog feature flag is enabled. Fail-closed: false
 * until flags load and report the flag on, and always false when PostHog
 * itself is disabled — local behaves exactly like staging/prod.
 */
export default function usePostHogFlag(flag) {
  const posthog = new PostHog();
  const [enabled, setEnabled] = useState(
    () => posthog.isFeatureEnabled(flag) === true
  );

  useEffect(() => {
    const unsubscribe = posthog.onFeatureFlags(() => {
      setEnabled(posthog.isFeatureEnabled(flag) === true);
    });

    return typeof unsubscribe === 'function' ? unsubscribe : undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flag]);

  return enabled;
}
